"use client";

import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterNavConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="flex flex-col gap-4">
        <li className="h-4 w-32 bg-slate-200 animate-pulse" />
        <li className="h-4 w-28 bg-slate-200 animate-pulse" />
        <li className="h-4 w-36 bg-slate-200 animate-pulse" />
        <li className="h-4 w-24 bg-slate-200 animate-pulse" />
      </ul>;
  }
  return <ul className="flex flex-col gap-4">
      {menuItems.map((item, i) => <li data-index={i} key={item.id}>
          <Link to={item.href || "#"} className="font-default font-normal text-sm text-slate-300 hover:text-blue-400 transition-colors duration-[220ms]" style={{
        letterSpacing: "-0.005em"
      }}>
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  const elsewhereLinks = [{
    label: "Email",
    href: "mailto:asahisearch@gmail.com"
  }, {
    label: "Phone",
    href: "tel:+1(475)332-6003"
  }];
  return <section data-section-id="1605" id="footer" className="relative w-full bg-slate-900 pt-32 pb-12 font-default dark">
      {}
      <div className="absolute top-0 left-0 right-0 flex items-center">
        <div className="flex-1 h-px bg-slate-700" />
        <div className="h-1.5 w-1.5 bg-blue-500 mr-0" />
      </div>

      <div className="max-w-[1440px] mx-auto px-6 md:px-16 lg:px-24">
        {}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-16 md:gap-8">
          {}
          <div className="md:col-span-5">
            <h2 className="font-default text-white" style={{
            fontWeight: 700,
            fontSize: "clamp(2.5rem, 5vw, 4.5rem)",
            letterSpacing: "-0.02em",
            lineHeight: 0.95
          }}>
              Asahi <em className="not-italic text-blue-400">Search</em>
            </h2>
            <p className="mt-8 font-default font-normal text-slate-400 max-w-sm" style={{
            fontSize: "clamp(0.9375rem, 1vw, 1rem)",
            lineHeight: 1.55
          }}>Precision growth for small to medium businesses.&nbsp;</p>
          </div>

          {}
          <div className="md:col-span-3 md:col-start-7">
            <div className="font-mono uppercase text-slate-500 mb-12" style={{
            fontSize: "clamp(0.6875rem, 0.78vw, 0.8125rem)",
            letterSpacing: "0.18em",
            lineHeight: 1
          }}>QUICK CONNECT</div>
            <MenuProvider menu_id="47">
              <FooterNavConsumer />
            </MenuProvider>
          </div>

          {}
          <div className="md:col-span-3 md:col-start-10">
            <div className="font-mono uppercase text-slate-500 mb-12" style={{
            fontSize: "clamp(0.6875rem, 0.78vw, 0.8125rem)",
            letterSpacing: "0.18em",
            lineHeight: 1
          }}>QUick CONNECT</div>
            <ul className="flex flex-col gap-4">
              {elsewhereLinks.map((link, i) => <li data-index={i} key={link.label}>
                  <Link to={link.href} className="group inline-block font-default font-normal text-sm text-slate-300 hover:text-blue-400 transition-colors duration-[220ms]" style={{
                textDecoration: "underline",
                textDecorationColor: "hsl(220 10% 45%)",
                textUnderlineOffset: "6px",
                textDecorationThickness: "1px"
              }}>
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>
        </div>

        {}
        <div className="mt-24 mb-12 h-px w-full bg-slate-700" />

        {}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8">
          <div className="md:col-span-6">
            <p className="font-mono uppercase text-slate-500" style={{
            fontSize: "11px",
            letterSpacing: "0.08em",
            lineHeight: 1.4
          }}>© ASAHI SEARCH · ALL RIGHTS RESERVED</p>
          </div>
          <div className="md:col-span-6 md:text-right">
            <p className="font-mono uppercase text-slate-500" style={{
            fontSize: "11px",
            letterSpacing: "0.08em",
            lineHeight: 1.4
          }}>
              Growth &infin; / Digital Strategy
            </p>
          </div>
        </div>
      </div>
    </section>;
}